import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { FieldDictionaryListService } from 'src/app/tabms/services/global/field-dictionary-list.service';
import { RTL } from 'src/app/@theme/const';
import { TabConst } from 'src/app/tabms/tab-consts';
import { FieldDictionaryDto } from 'src/app/tabms/models/base/base';
import { FieldDicHelperService } from 'src/app/tabms/services/global/field-dic-helper.service';

@Component({
  selector: 'app-form-textarea',
  templateUrl: './form-textarea.component.html',
  styleUrl: './form-textarea.component.scss'
})
export class FormTextareaComponent implements OnInit, OnDestroy {

  @Input() control
  @Input() fieldName
  @Input() customErrorStyle
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DEFAULTSIZE // New input for size control

  systemMenuId
  fieldList: FieldDictionaryDto
  currentLang
  placeholder?: string

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private activateRoute: ActivatedRoute,
    private baseService: BaseService,
    private themeLayoutService: ThemeLayoutService,
    private translate: TranslateService,
    private fieldDicHelperService: FieldDicHelperService
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();

    this.activateRoute.params.pipe(takeUntil(this.destroy$)).subscribe({
      next: (params) => {
        this.systemMenuId = params['id']
      }
    })

    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        (dir === RTL) ? this.currentLang = 'ar' : 'en'
        // this.getFieldData();
      }
    })

  }

  ngOnInit(): void {
    // this.getFieldData();
    //     combineLatest([
    //   this.activateRoute.params,
    //   this.themeLayoutService.directionChange
    // ])
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(([params, dir]) => {
    //     this.systemMenuId = params['id'];
    //     this.currentLang = (dir === RTL) ? 'ar' : 'en';
    //     this.getFieldData();
    //   });
    this.loadFieldData();

    this.baseService.createFormDisplay
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res?.show && res?.id === null) {
            this.loadFieldData(); // create only
          }
        },
      });
  }

  // getFieldData() {
  //   this.fieldDictionaryListService.getList().pipe(takeUntil(this.destroy$)).subscribe({
  //     next: (res) => {
  //       const pageData = res.find((x) => x.pageid == this.systemMenuId);
  //       if (!pageData) return

  //       this.fieldList = pageData.list.find((x) => x.fieldname.toLowerCase() === this.fieldName.toLowerCase());
  //       //this.setPlaceholder();
  //       const fieldNameTranslation = this.currentLang === 'ar' ?
  //         this.fieldList?.langvalue.find(x => x.culturename == 'ar-EG')?.value
  //         : this.fieldList?.langvalue.find(x => x.culturename == this.currentLang)?.value;
  //       console.log("fieldNameTranslation", fieldNameTranslation);


  //       this.placeholder = fieldNameTranslation;
  //       if (!this.fieldName || !fieldNameTranslation) {
  //         this.placeholder = this.translate.instant(this.fieldName);
  //       }
  //     }
  //   })
  // }
  //  private setPlaceholder() {
  //     if (!this.fieldList) {
  //       this.placeholder = this.translate.instant(this.fieldName);
  //       return;
  //     }

  //     const fieldNameTranslation = this.currentLang === 'ar'
  //       ? this.fieldList.langvalue.find(x => x.culturename === 'ar-EG')?.value
  //       : this.fieldList.langvalue.find(x => x.culturename === this.currentLang)?.value;

  //     this.placeholder = fieldNameTranslation || this.translate.instant(this.fieldName);
  //   }

  private loadFieldData() {
    // debugger
    this.fieldDicHelperService
      .getFieldData(this.fieldName, this.systemMenuId, true, this.control, this.currentLang)
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ placeholder, defaultValue, type, disabled }) => {
        // debugger
        this.placeholder = placeholder;
        if (defaultValue !== null && defaultValue !== undefined) {
          this.control.patchValue(defaultValue, { emitEvent: false, onlySelf: true });
        }
        console.log('disabled', disabled);

        if (disabled) {
          this.control?.disable({ emitEvent: false });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
